/**
 * relationships.service.ts — Layer 3: Relationships Domain
 */

import { getRequest, postRequest, putRequest, deleteRequest, deleteWithBodyRequest } from './http.service';
import { notifyClientChanged } from "../hooks/useClientChangeListener";
import {
  URL_RELATIONSHIPS,
  URL_RELATIONSHIPS_UPDATE,
  URL_RELATIONSHIPS_UNLINK,
  URL_RELATIONSHIP_BY_ID,
  URL_RELATIONSHIPS_BY_CLIENT,
} from './url.service';

/** Link a contact to a client */
export const linkContact = async (payload: Record<string, unknown>) => {
  const res: any = await postRequest(URL_RELATIONSHIPS, payload);
  // A contact-to-client link is the other way a calendar counterparty becomes
  // resolvable, so the same views need to re-derive (see notifyClientChanged).
  if (!res?.error) notifyClientChanged();
  return res;
};

/** Update an existing relationship (relationship type / primary status) */
export const updateRelationship = (payload: Record<string, unknown>) =>
  putRequest(URL_RELATIONSHIPS_UPDATE, payload);

/** Unlink a contact from a client */
export const unlinkContact = (payload: Record<string, unknown>) =>
  deleteWithBodyRequest(URL_RELATIONSHIPS_UNLINK, payload);

/** Get all relationships for a client */
export const fetchRelationshipsByClient = (clientId: string) =>
  getRequest(URL_RELATIONSHIPS_BY_CLIENT(clientId));

/** Update a relationship by its ID */
export const updateRelationshipById = (relationshipId: string, payload: Record<string, unknown>) =>
  putRequest(URL_RELATIONSHIP_BY_ID(relationshipId), payload);

/** Delete a relationship by ID */
export const deleteRelationshipById = (relationshipId: string) =>
  deleteRequest(URL_RELATIONSHIP_BY_ID(relationshipId));
